import React, { useState, useEffect, useContext } from "react";
import { BusinessContext } from "../../context/BusinessContext";
import CartContext from "../../context/CartContext";
import { Layout, Row, Col, Menu, Typography, Badge, Drawer, List, Button, Spin, Radio,  Space, } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import {
  HomeOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreOutlined,
  ShoppingOutlined,
  ArrowRightOutlined,
   MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import gplay from "../../assets/images/play_store.png";
import appstore from "../../assets/images/app_store.png";
import "../layouts/Footer.css";

const { Title } = Typography;
const currentYear = new Date().getFullYear();
const { Footer } = Layout;

const MyFooter = () => {
  const { businessInfo } = useContext(BusinessContext);
  const { cart, updateItem, updateOrderType } = useContext(CartContext);
  const location = useLocation();
  const navigate = useNavigate();
  
  const [isCartDrawerOpen, setIsCartDrawerOpen] = useState(false);
  const [Cartloading, setCartLoading] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const [activeKey, setActiveKey] = useState("home");

  const orderType = cart?.Carts?.order_type;
  const comparisionDiscount = cart?.Carts?.ComparisonRate ?? 0;
  const cartItemsCount = cart?.data?.length || 0;

  const showCartDrawer = () => setIsCartDrawerOpen(true);
  const closeCartDrawer = () => setIsCartDrawerOpen(false);

  // Update active key based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveKey("home");
    else if (path === "/menu") setActiveKey("menu");
    else if (path === "/our-offer") setActiveKey("offers");
  }, [location]);

  // Handle scroll events
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;

    if (scrollPosition + windowHeight >= pageHeight - 100) {
      setIsAtTop(false);
    } else if (scrollPosition <= 100) {
      setIsAtTop(true);
    }
  };

  const handleArrowClick = () => {
    if (isAtTop) {
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Cart functions
  const handleUpdateItem = async (itemId, newQuantity) => {
    setCartLoading(true);
    try {
      await updateItem(itemId, newQuantity);
    } catch (error) {
      console.error("Failed to update item:", error);
    } finally {
      setCartLoading(false);
    }
  };

  const handleUpdateOrderType = async (order_type) => {
    setCartLoading(true);
    try {
      await updateOrderType(order_type);
    } catch (error) {
      console.error("Failed to update order type:", error);
    } finally {
      setCartLoading(false);
    }
  };

  const handleCheckout = () => {
    closeCartDrawer();
    navigate("/order");
  };

  const handleCartClick = (e) => {
    e.preventDefault();
    showCartDrawer();
  };

  // Cart calculation functions
  const getItemBasePrice = (item) => {
    if (item?.master_size) {
      return Number(item.master_size.delivery_item_price || 0);
    }
    return Number(item.delivery_item_price || 0);
  };

  const getAddonPrice = (item) => {
    if (!item?.extra_addons || item.extra_addons.length === 0) return 0;
    return item.extra_addons.reduce(
      (sum, addon) => sum + addon.addon_price * addon.quantity,
      0
    );
  };

  const getItemTotal = (item) => {
    const basePrice = getItemBasePrice(item);
    const addonPrice = getAddonPrice(item);
    return (basePrice + addonPrice) * item.quantity;
  };

  const subtotal = cart?.data?.reduce((total, item) => total + getItemTotal(item), 0) || 0;

  // Mobile menu items
const mobileMenuItems = useMemo(() => [
  {
    key: "home",
    icon: <HomeOutlined />,
    label: <Link to="/" className="mobile-nav-link">Home</Link>,
  },
  {
    key: "menu",
    icon: <ShoppingOutlined />,
    label: <Link to="/menu" className="mobile-nav-link">Online Order</Link>,
  },
  {
    key: "cart",
    icon: (
      <Badge
        count={cartItemsCount}
        size="small"
        offset={[-5, 5]}
        className="cart-badge"
      >
        <ShoppingCartOutlined />
      </Badge>
    ),
    label: (
      <a href="#cart" className="mobile-nav-link" onClick={handleCartClick}>Cart</a>
    ),
  },
  {
    key: "offers",
    icon: <AppstoreOutlined />,
    label: <Link to="/our-offer" className="mobile-nav-link">Our Offers</Link>,
  },
], [cartItemsCount]);

  // Check if businessInfo and its properties are loaded
  const restaurantName = businessInfo?.businessInfo?.[0]?.restaurant_name_en || "Default Restaurant Name";

  if (!businessInfo || !businessInfo.businessInfo) {
    return null;
  }

  return (
    <>
      {/* Desktop Footer */}
      <Footer className="footerSection desktopFooter">
        <div className="topFooter">
          <Row gutter={20}>
            <Col xs={24} sm={24} md={16} xl={16} xxl={16}>
              <div className="footerLeft">
                {/* {businessInfo?.businessInfo?.[0]?.food_hygine_rating_img && (
                  <Link
                    to={businessInfo?.businessInfo?.[0]?.food_hygine_rating_url}
                    className="hygiene-rating-link"
                    target="_blank"
                  >
                    <img
                      style={{ width: "42%", marginLeft: "10px" }}
                      src={businessInfo?.businessInfo?.[0]?.food_hygine_rating_img}
                      alt={restaurantName}
                      title={restaurantName}
                    />
                  </Link>
                )} */}

                <Menu  mode={window.innerWidth <= 768 ? "inline" : "horizontal"}  className="footerMenu">
                  {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.about_us_en && (
                    <Menu.Item key="1">
                      <a href="/about-us" title={businessInfo?.businessInfo?.[0]?.homelng?.[0]?.about_us_en}>
                        {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.about_us_en}
                      </a>
                    </Menu.Item>
                  )}
                  {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.about_us_en && (
                    <Menu.Item key="faqs">
                      <a href="/faqs" title="FAQs">FAQs</a>
                    </Menu.Item>
                  )}
                  {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.gallery_en && (
                    <Menu.Item key="2">
                      <a href="/gallery" title={businessInfo?.businessInfo?.[0]?.homelng?.[0]?.gallery_en}>
                        {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.gallery_en}
                      </a>
                    </Menu.Item>
                  )}
                  {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.privacy_policy_en && (
                    <Menu.Item key="3">
                      <a href="/privacy" title={businessInfo?.businessInfo?.[0]?.homelng?.[0]?.privacy_policy_en}>
                        {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.privacy_policy_en}
                      </a>
                    </Menu.Item>
                  )}
                  {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.terms_conditions_en && (
                    <Menu.Item key="4">
                      <a href="/terms-conditions" title={businessInfo?.businessInfo?.[0]?.homelng?.[0]?.terms_conditions_en}>
                        {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.terms_conditions_en}
                      </a>
                    </Menu.Item>
                  )}
                  {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.allergy_en && (
                    <Menu.Item key="5">
                      <a href="/nutrition-allergy" title={businessInfo?.businessInfo?.[0]?.homelng?.[0]?.allergy_en}>
                        {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.allergy_en}
                      </a>
                    </Menu.Item>
                  )}
                </Menu>
              </div>
            </Col>
         
    


            {/* <Col xs={24} sm={24} md={8} xl={8} xxl={8}>
              <Title level={4} className="footerHeading">
                {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.download_app_en || "Download the Curry Inn app"}
              </Title>
              <Title level={5} className="downloadapp_subtitle">
                {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.download_anywhere_en || " Order anytime and anywhere!"}
              </Title>
              <div className="footerAppStore">
                <Link className="appStoreBtn">
                  <img src={gplay} alt="Google Play" />
                </Link>
                <Link className="appStoreBtn">
                  <img src={appstore} alt="App Store" />
                </Link>
                <p>Our Trusted Delivery Partner - PDQ2.com Driver Network!</p>
              </div>
            </Col> */}
          </Row>
        </div>
        <div className="copyrightFooter">
         {/*  <Link to="https://pdq2.com/" target="_blank" className="ftLogo">
            <img
              style={{ width: "85px" }}
              src="https://pdq2.com/assets/images/users/pdq2-1.jpg"
              alt="Restaurant Logo"
            />
          </Link> */}
          <Title level={1} style={{ color: "#fff", fontSize:"17px" }}>
            {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.pdq2_delivery_description_en ||
              "For your safety and security. Our deliveries are now handle by PDQ2.COM"}
          </Title>
          <div style={{ fontSize: "15px", fontWeight: 500 }}>
            {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.powered_by_en || "Powered By "} PDQ2.com
          </div>
        </div>

        <div className="copyrightFooter" style={{ paddingBottom: 0 }}>
          {restaurantName} {currentYear}{" "}
          {businessInfo?.businessInfo?.[0]?.homelng?.[0]?.created_by_en || "Created By "} PDQ2 Group Limited
        </div>
      </Footer>

      {/* Scroll to Top/Bottom Button */}
      <div className="scroll-to-top" onClick={handleArrowClick}>
        {isAtTop ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 15l7-7 7 7"></path>
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 9l-7 7-7-7"></path>
          </svg>
        )}
      </div>

      {/* Enhanced Mobile Footer */}
     <Footer className="mobile-footer">
  <div className="mobile-menu-wrapper">
    {mobileMenuItems.map((item) => {
      const isCart = item.key === "cart";

      return (
        <div
          key={item.key}
          className={`mobile-menu-item ${activeKey === item.key ? "active" : ""}`}
          onClick={isCart ? handleCartClick : undefined} // Cart drawer
        >
          <div className="icon-wrapper">
            {isCart ? (
              <Badge 
                count={cartItemsCount} 
                size="small" 
                offset={[-5, 5]} 
                className="cart-badge"
              >
                {item.icon}
              </Badge>
            ) : (
              item.icon
            )}
          </div>

          <div className="label">
            {isCart
              ? "Cart"
              : item.label // <-- render Link as-is for navigation
            }
          </div>
        </div>
      );
    })}
  </div>
</Footer>



      {/* Cart Drawer - Same as Header */}
      <Drawer
        title="Cart Summary"
        placement="right"
        onClose={closeCartDrawer}
        open={isCartDrawerOpen}
        width={450}
        style={{ zIndex: 999999, position: "relative" }}
      >
        <div className="cartListItem">
          <List
            locale={{ emptyText: "Your cart is empty" }}
            dataSource={cart?.data || []}
            renderItem={(item) => {
              const basePrice = getItemBasePrice(item);
              const addonsTotal = getAddonPrice(item);
              const itemTotal = (basePrice + addonsTotal) * item.quantity;

              return (
                <List.Item key={item.id}>
                  <div className="headercartItemContainer">
                    <div className="headercartItemDetails">
                      <div className="headercartItemName">
                        {item.quantity} x {item.food_items?.food_item_name_en}
                      </div>
                      <div className="headercartItemSize">
                        {item.master_size ? (
                          <span>
                            + {item.master_size.food_item_size_name_en}{" "}
                            <span>(&pound;{(basePrice * item.quantity).toFixed(2)})</span>
                          </span>
                        ) : (
                          <span>(&pound;{(basePrice * item.quantity).toFixed(2)})</span>
                        )}
                      </div>
                      {item.extra_addons?.length > 0 && (
                        <div className="headercartItemExtras">
                          {item.extra_addons.map((addon) => (
                            <span key={addon.id}>
                              + {addon.name} ({addon.quantity} x &pound;
                              {addon.addon_price.toFixed(2)})
                            </span>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="headercartInputQtyWrap">
                      <div className="headercartQuantityControls">
                        <Button
                          type="default"
                          className="headercartMinusBtn"
                          icon={Cartloading ? <Spin size="small" /> : ""}
                          onClick={() => handleUpdateItem(item.id, item.quantity - 1)}
                          disabled={Cartloading}
                        >
                          -
                        </Button>
                        <div className="headercartInputQty">{item.quantity}</div>
                        <Button
                          type="default"
                          className="headercartPlusBtn"
                          icon={Cartloading ? <Spin size="small" /> : ""}
                          onClick={() => handleUpdateItem(item.id, item.quantity + 1)}
                          disabled={Cartloading}
                        >
                          +
                        </Button>
                      </div>
                      <div className="headercartItemPricedetails">
                        &pound;{itemTotal.toFixed(2)}
                      </div>
                    </div>
                  </div>
                </List.Item>
              );
            }}
          />
        </div>

        {cart?.data?.length > 0 && (
          <div className="headerCartOrderType">
            <Title level={4} className="billHead">Choose Order Type</Title>
            <Radio.Group
              value={String(orderType)}
              onChange={(e) => handleUpdateOrderType(e.target.value)}
              buttonStyle="solid"
              className="customRadioGroup"
            >
              {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.pickup_type_enable === 0 && (
                <Radio.Button value="1" className="radioButton">
                  <div className="radioContent">
                    <svg viewBox="0 0 24 24" height="40" fill="currentColor">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.869 3.284a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2.109 9.162a8.519 8.519 0 0 1-2.418-1.266l-.288-.218a.25.25 0 0 0-.4.2v1.804a.993.993 0 0 0 .355.754 17.2 17.2 0 0 1 4.568 7.518 1.5 1.5 0 1 1-2.846.952 16.622 16.622 0 0 0-2.416-4.927.25.25 0 0 0-.433.081 17.332 17.332 0 0 1-2.56 5.309 1.5 1.5 0 1 1-2.344-1.873 12.745 12.745 0 0 0 2.213-4.7c.308-1.385.463-2.799.463-4.217v-1.357a.25.25 0 0 0-.38-.214 3.413 3.413 0 0 0-1.622 2.944 1.5 1.5 0 0 1-1.5 1.426 1.5 1.5 0 0 1-1.5-1.613 6.32 6.32 0 0 1 3.511-5.571 5.7 5.7 0 0 1 5.963.54l1.016.762a5.514 5.514 0 0 0 1.564.82l1.105.367a1.551 1.551 0 0 1 1.083 1.673 1.5 1.5 0 0 1-1.958 1.198l-1.176-.392Z"
                      ></path>
                    </svg>
                    <span>{businessInfo?.businessInfo?.[0]?.homelng?.[0]?.collection_en ?? "Collection"}</span>
                    <span>{businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.pickup_estimate_time}min Approx</span>
                  </div>
                </Radio.Button>
              )}
              {businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.delivery_type_enable === 0 && (
                <Radio.Button value="0" className="radioButton">
                  <div className="radioContent">
                    <svg viewBox="0 0 24 24" height="40" fill="currentColor">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.401 9.602c.281.281.666.439 1.062.439h.039a1.48 1.48 0 0 0 1.075-.496l3.157-3.507a1.505 1.505 0 0 0-.055-2.071L8.098 2.385A1.547 1.547 0 0 0 7 1.947c-.41.01-.802.191-1.076.495l-3.16 3.512a1.502 1.502 0 0 0 .054 2.066l1.583 1.582Zm6.321 2.132 1.451-1.659a8.276 8.276 0 0 0 4.655 1.42h.672a1.5 1.5 0 1 0 0-3h-.672a5.363 5.363 0 0 1-3.767-1.561 1.407 1.407 0 0 0-1.111-.438 1.5 1.5 0 0 0-1.079.511l-3.5 4a1.5 1.5 0 0 0 .3 2.236l.664.442a5.261 5.261 0 0 1 2.2 5.484 1.5 1.5 0 1 0 2.928.651 8.285 8.285 0 0 0-2.741-8.086ZM22 18.495a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm2 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-17 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm2 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm3.125-14.5a2.375 2.375 0 1 1 4.75 0 2.375 2.375 0 0 1-4.75 0Z"
                      ></path>
                    </svg>
                    <span>{businessInfo?.businessInfo?.[0]?.homelng?.[0]?.delivery_en ?? "Delivery"}</span>
                    <span>{businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.delivery_estimate_time}min Approx</span>
                  </div>
                </Radio.Button>
              )}
            </Radio.Group>
          </div>
        )}

       {/* Dynamic Calculation Logic */}
     
     {cart.data?.length > 0 && (() => {
       // ✅ Calculate subtotal including size & addons
       const subtotal =
         cart.data?.reduce((total, item) => {
           const basePrice = item?.master_size
             ? Number(item.master_size.delivery_item_price || 0)
             : Number(item.delivery_item_price || 0);
     
           const addonsTotal =
             item?.extra_addons?.reduce(
               (sum, addon) => sum + addon.addon_price * addon.quantity,
               0
             ) || 0;
     
           return total + (basePrice + addonsTotal) * item.quantity;
         }, 0) || 0;
     
       // ✅ Delivery fee logic
       let deliveryFee = 0;
       if (businessInfo?.businessInfo?.[0]?.portal_info?.[0]?.delivery_type_enable === 0) {
         const freeDeliveryThreshold =
           businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.free_delivery_above_subTotal;
         const defaultDeliveryCharge =
           businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.default_delivery_charge ?? 0;
     
         if (freeDeliveryThreshold && subtotal < freeDeliveryThreshold) {
           deliveryFee = Number(defaultDeliveryCharge);
         } else {
           deliveryFee = Number(defaultDeliveryCharge);
         }
       }
     
       // ✅ Packaging fee
       let packageFee = 0;
       if (businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.packaging_charge_enable === 1) {
         packageFee = Number(
           businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.packaging_charge ?? 0
         );
       }
     
       // ✅ Discounts
       const discountRate =
         (businessInfo?.businessInfo?.[0]?.pdq2_agreed_discount ?? 0) / 100;
       const discount = subtotal * discountRate;
       const totalComparisonDiscount = subtotal * (comparisionDiscount || 0);
     
       // ✅ Grand total with all conditions
       let grandTotal;
       if (orderType === 0) {
         // Delivery order
         grandTotal = subtotal + deliveryFee + packageFee - discount;
       } else {
         // Pickup order
         grandTotal = subtotal + packageFee - discount;
       }
     
       const totalSavings = discount + totalComparisonDiscount;
     
       //console.log("totalComparisonDiscount", totalComparisonDiscount);
     
       return (
         <div>
     {/* Delivery = 0 and Collection = 1 */} {orderType === 0 && subtotal < businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_delivery_order && ( <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#ffe6e6', padding: '10px', marginBottom: '10px', borderRadius: '4px' }}> <Title level={4} style={{ margin: 0 }}> The minimum order value is &pound;{businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_delivery_order} </Title> </div> )} {orderType === 1 && subtotal < businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_pickup_order && ( <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#ffe6e6', padding: '10px', marginBottom: '10px', borderRadius: '4px' }}> <Title level={4} style={{ margin: 0 }}> The minimum order value is &pound;{businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_pickup_order} </Title> </div> )}
           <Title level={4} className="billHead">Bill Summary</Title>
           <div className="billSummary">
             <div className="billItemWrap">
               <div className="billItemTitle">Sub Total</div>
               <div className="billItemValue">&pound;{subtotal.toFixed(2)}</div>
             </div>
     
             {orderType === 0 && deliveryFee > 0 && (
               <div className="billItemWrap">
                 <div className="billItemTitle">Delivery Fee</div>
                 <div className="billItemValue">&pound;{deliveryFee.toFixed(2)}</div>
               </div>
             )}
     
             {packageFee > 0 && (
               <div className="billItemWrap">
                 <div className="billItemTitle">Service Fee</div>
                 <div className="billItemValue">&pound;{packageFee.toFixed(2)}</div>
               </div>
             )}
     
             {discount > 0 && (
               <div className="billItemWrap">
                 <div className="billItemTitle">Direct Discount Amount</div>
                 <div className="billItemValue">-&pound;{discount.toFixed(2)}</div>
               </div>
             )}
     
{/*              {totalComparisonDiscount > 0 && (
               <div className="billItemWrap">
                 <div className="billItemTitle">Comparison Discount</div>
                 <div className="billItemValue">-&pound;{totalComparisonDiscount.toFixed(2)}</div>
               </div>
             )} */}
     
             <div className="billItemWrap">
               <div className="billItemTitle">Grand Total</div>
               <div className="billItemValue">&pound;{grandTotal.toFixed(2)}</div>
             </div>
     
             {totalSavings > 0 && (
               <div className="billTotalDiscountWrap">
                 <div className="billTotalDiscountTitle">Your Total Direct Order Savings</div>
                 <div className="billTotalDiscountValue">&pound;{totalSavings.toFixed(2)}</div>
               </div>
             )}
           </div>
     
           {/* ✅ Checkout Button */}
           {orderType === 0 && subtotal > businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_delivery_order && (
             <div className="billPayWrap" style={{ marginTop: "16px" }}>
               <Button type="primary" onClick={handleCheckout} className="checkoutButton">
                 Place Order &pound;{grandTotal.toFixed(2)} <ArrowRightOutlined />
               </Button>
             </div>
           )}
     
           {orderType === 1 && subtotal > businessInfo?.businessInfo?.[0]?.charge_info?.[0]?.min_pickup_order && (
             <div className="billPayWrap" style={{ marginTop: "16px" }}>
               <Button type="primary" onClick={handleCheckout} className="checkoutButton">
                 Place Order &pound;{grandTotal.toFixed(2)} <ArrowRightOutlined />
               </Button>
             </div>
           )}
         </div>
       );
     })()}
      </Drawer>
    </>
  );
};

export default MyFooter;